import { useState } from 'react';

/** The Telegram photo when there is one and it loads; the initials otherwise. */
export function Avatar({ photoUrl, initials, className }: { photoUrl: string | null; initials: string; className: string }) {
  const [broken, setBroken] = useState(false);
  const photo = !!photoUrl && !broken;
  return (
    // The brand background is for the initials; a photo with transparent corners must not show a red frame.
    <span className={className} aria-hidden="true" style={photo ? { background: 'transparent' } : undefined}>
      {photo ? (
        <img
          src={photoUrl!}
          alt=""
          referrerPolicy="no-referrer"
          onError={() => setBroken(true)}
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit', display: 'block' }}
        />
      ) : (
        initials
      )}
    </span>
  );
}
